import { combineReducers } from "redux";

import { tasks } from './tasks';
import { stock } from './stock';
import { taskSelected } from './taskSelected';
import { user } from './user';
import { clients } from 'clients/services/reducers';
import { invoices } from "invoices/services/store/reducers";
import { tickets } from "tickets/services/store/reducers";
import { notes } from "../../../notes/services/store/reducer";
import { reacondicionados } from './reacondicionados';

export default combineReducers({
    tasks, taskSelected, user, stock, clients, invoices, tickets, notes, reacondicionados
});